import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DirectoryItem } from '../../_models/directory.model';

@Injectable({ providedIn: 'root' })
export class SupplierModalService {
  private supplierDataSubject = new BehaviorSubject<DirectoryItem | null>(null);
  supplierData$ = this.supplierDataSubject.asObservable();

  openWithSupplier(data: DirectoryItem): void {
    this.supplierDataSubject.next(data);
  }

  clearSupplierData(): void {
    this.supplierDataSubject.next(null);
  }
}
